import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { FiEdit } from "react-icons/fi";
import { FaRegClone } from "react-icons/fa";
import Switch from "@material-ui/core/Switch";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import MenuItem from "@material-ui/core/MenuItem";
import Hidden from "@material-ui/core/Hidden";

import {
  removeProduct,
  loadMenu,
  changeVisibilityOfProduct,
  cloneProduct,
} from "../../Store/Modules/Menu/Actions";
import { setProductDialogState } from "../../Store/Modules/Dialogs/Actions";
import Price from "../Price";
import BtnRemove from "../BtnRemove";
import MoreVertMenu from "../MoreVertMenu";

import {
  Actions,
  Container,
  ProductName,
  MobileHidden,
  ActionOpacity,
} from "./style";

export default function Product({ data: product }) {
  const dispatch = useDispatch();

  const handleSwitchChange = (input) => (event) => {
    event.stopPropagation();
    dispatch(changeVisibilityOfProduct(product._id, event.target.checked));
  };

  const handleEditProduct = () => {
    dispatch(setProductDialogState("show", true));
    dispatch(
      setProductDialogState("data", {
        productId: product._id,
        printDescription: product.printDescription,
      })
    );
  };

  const handleRemove = useCallback(() => {
    dispatch(removeProduct(product._id, product.categoryId));
  }, []);

  const handleClone = useCallback(() => {
    dispatch(cloneProduct(product._id));
  }, [product]);

  return (
    <Container>
      <ActionOpacity disabled={!product.is_active}>
        <ProductName onClick={handleEditProduct}>
          {product.printDescription}
        </ProductName>

        <MobileHidden>
          <Price price={product.price} />
        </MobileHidden>
      </ActionOpacity>

      <Actions>
        <Hidden xsDown={true}>
          <Tooltip arrow placement="bottom" title="Alterar produto">
            <Button onClick={handleEditProduct}>
              <FiEdit size="20px" />
            </Button>
          </Tooltip>
          <Tooltip arrow placement="bottom" title="Duplicar produto">
            <Button onClick={handleClone}>
              <FaRegClone size="18px" />
            </Button>
          </Tooltip>
          <Tooltip arrow placement="bottom" title="Excluir produto">
            <span>
              <BtnRemove
                productName={product.printDescription}
                onRemove={() => handleRemove()}
              />
            </span>
          </Tooltip>
        </Hidden>
        <Tooltip arrow placement="bottom" title="Ativar/Desativar produto">
          <Switch
            onChange={handleSwitchChange("is_active")}
            checked={product.is_active}
            color="primary"
            onClick={(e) => e.stopPropagation()}
          />
        </Tooltip>
        <Hidden smUp={true}>
          <MoreVertMenu>
            <MenuItem onClick={handleEditProduct}>Editar Produto</MenuItem>
            <MenuItem onClick={handleClone}>Duplicar Produto</MenuItem>
            <MenuItem onClick={handleRemove}>Remover Produto</MenuItem>
          </MoreVertMenu>
        </Hidden>
      </Actions>
    </Container>
  );
}
